import React from 'react';
import { useTranslation } from 'react-i18next';
import './.video-section-wistia.less';
import { WistiaPlayer } from "@wistia/wistia-player-react"; 


function VideoSection(props: { url: any; }) {
    console.log('VideoSection props', props);
    const { t } = useTranslation();
    if(!props.url){
        return <></>
        
    }

    return (
        <div className='wistia-frame'>
            <div className='video-aspect-ratio'>
                <WistiaPlayer mediaId={`${props.url}`} />
            </div>    
        </div>
    );
}

export default VideoSection;